// DEPENDENCIES is defined in vue.config.js as a webpack plugin and contains
// version numbers for a few main dependencies of drawmote.

// eslint-disable-next-line no-undef
export default DEPENDENCIES
